<script setup lang="ts">
</script>

<template>
  <div class="grid grid-cols-1 lg:grid-cols-2 gap-11">
    <slot></slot>
  </div>
</template>
